import React from 'react';
import { FormattedMessage } from 'react-intl';
import Proptypes from 'prop-types';
import {
  GridCardPosition,
  GridCardVariant,
  SaleEventHeaderVariant,
  TradeState
} from '../../../../_shared/types/trade';
import truncateText from '../../../../_shared/utils/truncateText';
import BadgeWithTooltip from '../../../../_shared/components/BadgeWithTooltip';
import { StyledTradeCardContainer } from '../../../TradeCard/GridTradeCard/Styles';

import {
  StyledActive,
  StyledContent,
  StyledDealerEvent,
  StyledDealerGroup,
  StyledDealerGroupName,
  StyledEventName,
  StyledHeader,
  StyledHostedBy,
  StyledLaunchTime,
  StyledSaleEventStartCard,
  StyledSaleEventStartCardContainer,
  StyledSellerBadge,
  StyledVehiclesTotal
} from './Styles';

const propTypes = {
  id: Proptypes.string.isRequired,
  position: Proptypes.oneOf([
    GridCardPosition.LEFT,
    GridCardPosition.BETWEEN,
    GridCardPosition.RIGHT
  ]).isRequired,
  eventVariant: Proptypes.oneOf([
    SaleEventHeaderVariant.COMPLETE,
    SaleEventHeaderVariant.CONTINUED
  ]).isRequired,
  tradeState: Proptypes.oneOf([TradeState.upcoming, TradeState.active])
    .isRequired,
  tradeSummary: Proptypes.objectOf(Proptypes.any).isRequired,
  shouldHideHostedBy: Proptypes.bool.isRequired,
  isChangeHostedBy: Proptypes.bool.isRequired,
  launchIdSale: Proptypes.string.isRequired,
  launchValues: Proptypes.objectOf(Proptypes.any).isRequired
};

const GridSaleEventHeader = ({
  id,
  position,
  eventVariant,
  tradeState,
  tradeSummary: { saleEventSummary, dealer },
  shouldHideHostedBy,
  isChangeHostedBy,
  launchIdSale,
  launchValues
}) => (
  <StyledTradeCardContainer
    id={id}
    data-testid={id}
    variant={GridCardVariant.EVENT_START}
    position={position}
    tradeState={tradeState}
  >
    <StyledSaleEventStartCardContainer>
      <StyledSaleEventStartCard>
        <StyledHeader>
          <StyledDealerEvent>
            {eventVariant === SaleEventHeaderVariant.CONTINUED ? (
              <FormattedMessage id="list.saleEvent.dealer.event.continued" />
            ) : (
              <FormattedMessage id="list.saleEvent.dealer.event" />
            )}
          </StyledDealerEvent>
          <StyledVehiclesTotal>
            {saleEventSummary?.numberOfTrades}{' '}
            <FormattedMessage id="list.saleEvent.vehicles" />
          </StyledVehiclesTotal>
        </StyledHeader>
        <StyledEventName>
          {truncateText(saleEventSummary?.name, 40)}
        </StyledEventName>
        <StyledContent>
          {dealer?.displayName && !shouldHideHostedBy && (
            <>
              <StyledHostedBy>
                <FormattedMessage id="list.saleEvent.hosted.by" />
              </StyledHostedBy>
              <StyledDealerGroup>
                {!isChangeHostedBy && dealer?.dealerBadges?.length > 0 && (
                  <StyledSellerBadge>
                    <BadgeWithTooltip badges={dealer?.dealerBadges} />
                  </StyledSellerBadge>
                )}
                <StyledDealerGroupName>
                  {truncateText(
                    isChangeHostedBy
                      ? saleEventSummary?.dgnNetwork
                      : dealer?.displayName,
                    55
                  )}
                </StyledDealerGroupName>
              </StyledDealerGroup>
            </>
          )}
          {tradeState &&
            tradeState === TradeState.upcoming &&
            launchIdSale &&
            launchValues && (
              <>
                <StyledActive>
                  <FormattedMessage id="list.saleEvent.active" />
                </StyledActive>
                <StyledLaunchTime>
                  <FormattedMessage id={launchIdSale} values={launchValues} />
                </StyledLaunchTime>
              </>
            )}
        </StyledContent>
      </StyledSaleEventStartCard>
    </StyledSaleEventStartCardContainer>
  </StyledTradeCardContainer>
);

GridSaleEventHeader.propTypes = propTypes;

export default GridSaleEventHeader;
